import { CollapsibleArea } from '@framework/ui';
import { Divider } from 'antd';
import React from 'react';

export interface IFrontFilterPanelProps {
  open?: boolean;
  children?: React.ReactNode;
  /** id: per area collassabile (non utilizzati con removeCollapse) */
  id: string;
  /** buttonId: per area collassabile (non utilizzati con removeCollapse) */
  buttonId?: string;
}

export function FrontFilterPanel(props: IFrontFilterPanelProps) {
  const { open = false, children, id, buttonId, ...rest } = props;

  return (
    <>
      <CollapsibleArea opened={open} id={id} buttonId={buttonId}>
        {children}
      </CollapsibleArea>
      {open && <Divider style={{ margin: 0 }} />}
    </>
  );
}
